import { render, staticRenderFns } from "./TraceabilityProgressBar.vue?vue&type=template&id=5ac1a890"
import script from "./TraceabilityProgressBar.vue?vue&type=script&lang=js"
export * from "./TraceabilityProgressBar.vue?vue&type=script&lang=js"
import style0 from "./TraceabilityProgressBar.vue?vue&type=style&index=0&id=5ac1a890&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports